import dynamicLaborSummaryItemComponentUrl from './dynamicLaborSummaryItemComponent.html';

class DynamicLaborSummaryItemComponentCtrl {
  constructor(Authentication, LaborUISchema, PersonaCollection, Utils, $state) {
    'ngInject';

    Object.assign(this, { Authentication, LaborUISchema, PersonaCollection, Utils, $state });
  }

  $onInit() {
    const { hasVisitiedLaborCostSettingsTab } = this.Authentication.user.settings.clientFlags;
    this.hasVisitiedLaborCostSettingsTab = hasVisitiedLaborCostSettingsTab;
  }

  isRed(item) {
    return this.LaborUISchema.evalColor(item, this.summary).red;
  }
}

export default {
  templateUrl: dynamicLaborSummaryItemComponentUrl,
  controller: DynamicLaborSummaryItemComponentCtrl,
  controllerAs: 'ctrl',
  bindings: {
    summary: '<',
    summariesByLocation: '<',
    item: '<',
    options: '<',
    byLocationSuffix: '<',
    isLast: '<',
    openAddShiftModal: '&',
  },
};
